module.exports = __webpack_public_path__ + "static/media/81.65697d33.jpg";